module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 40 39",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#envelope",
      toString: function () {
        return this.url;
      }
    }